import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WdxFeatureSvgModule } from '@wdx/shared/components/wdx-feature-svg';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { WdxIconButtonModule } from '@wdx/shared/components/wdx-icon-button';
import { WdxSpinnerModule } from '@wdx/shared/components/wdx-spinner';
import { CamelCasePipe, TranslateTokenisedStringPipe } from '@wdx/shared/utils';

export type PortfolioLoadingStates =
    | 'dataConnectionError'
    | 'loading'
    | 'loaded'
    | 'noData';

@Component({
    selector: 'wdx-portfolio-not-loaded',
    imports: [
        WdxIconModule,
        WdxSpinnerModule,
        WdxFeatureSvgModule,
        WdxIconButtonModule,
        CamelCasePipe,
        TranslateTokenisedStringPipe,
    ],
    templateUrl: './portfolio-not-loaded.component.html',
    styleUrl: './portfolio-not-loaded.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortfolioNotLoadedComponent {
    @Input() status: PortfolioLoadingStates = 'loading';
    @Input() dataTypeLabel = 'data';
    @Input() connectionErrorMessage = '';

    public errorHeader = 'PORTOFOLIO_ERROR_MESSAGE';
    public showConnectionError = false;

    showHideConnectionError() {
        this.showConnectionError = !this.showConnectionError;
    }
}
